import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { ProtectedRoute } from './components/ProtectedRoute';
import { useAuth } from './auth/AuthContext';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { VerifyEmail } from './pages/VerifyEmail';
import { Profile } from './pages/Profile';
import { ChangePassword } from './pages/ChangePassword';
import { Dashboard } from './pages/admin/Dashboard';
import { Payments as AdminPayments } from './pages/admin/Payments';
import { Dealers } from './pages/admin/Dealers';
import { Staff } from './pages/admin/Staff';
import { Banks } from './pages/admin/Banks';
import { Settings } from './pages/admin/Settings';
import { BayiHome } from './pages/bayi/Home';
import { NewPayment } from './pages/bayi/NewPayment';
import { PaymentHistory } from './pages/bayi/PaymentHistory';
import { Contracts } from './pages/bayi/Contracts';
import { PaymentResult } from './pages/PaymentResult';
import { Help } from './pages/Help';
import { DesignSystem } from './pages/DesignSystem';

/** Kök yönlendirme — role göre ana sayfaya götürür. */
function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <div className="route-loading">Yükleniyor…</div>;
  if (!user) return <Navigate to="/giris" replace />;
  return <Navigate to={user.role === 'bayi' ? '/bayi' : '/panel'} replace />;
}

export function App() {
  return (
    <Routes>
      {/* herkese açık */}
      <Route path="/giris" element={<Login />} />
      <Route path="/kayit" element={<Register />} />
      <Route path="/e-posta-onay" element={<VerifyEmail />} />
      {/* Tasarım sistemi vitrini yalnız geliştirmede erişilir (canlıda gizli). */}
      {import.meta.env.DEV && <Route path="/tasarim" element={<DesignSystem />} />}

      {/* korumalı — uygulama kabuğu içinde */}
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route
          path="/panel"
          element={
            <ProtectedRoute roles={['admin', 'manager']}>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/panel/odemeler"
          element={<ProtectedRoute roles={['admin', 'manager']}><AdminPayments /></ProtectedRoute>}
        />
        <Route
          path="/panel/bayiler"
          element={<ProtectedRoute roles={['admin', 'manager']}><Dealers /></ProtectedRoute>}
        />
        <Route
          path="/panel/kullanicilar"
          element={<ProtectedRoute roles={['admin']}><Staff /></ProtectedRoute>}
        />
        <Route
          path="/panel/bankalar"
          element={<ProtectedRoute roles={['admin']}><Banks /></ProtectedRoute>}
        />
        <Route
          path="/panel/ayarlar"
          element={<ProtectedRoute roles={['admin']}><Settings /></ProtectedRoute>}
        />
        <Route
          path="/panel/yardim"
          element={<ProtectedRoute roles={['admin', 'manager']}><Help /></ProtectedRoute>}
        />
        <Route
          path="/bayi"
          element={
            <ProtectedRoute roles={['bayi']}>
              <BayiHome />
            </ProtectedRoute>
          }
        />
        <Route
          path="/odeme"
          element={
            <ProtectedRoute roles={['bayi']}>
              <NewPayment />
            </ProtectedRoute>
          }
        />
        <Route
          path="/odemelerim"
          element={
            <ProtectedRoute roles={['bayi']}>
              <PaymentHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sozlesmeler"
          element={<ProtectedRoute roles={['bayi']}><Contracts /></ProtectedRoute>}
        />
        <Route path="/odeme/sonuc" element={<PaymentResult />} />
        <Route path="/profil" element={<Profile />} />
        <Route path="/sifre" element={<ChangePassword />} />
      </Route>

      <Route path="/" element={<RootRedirect />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
